export default __webpack_public_path__ + "static/1098-73a181af5cf954bf8a21e930835632e7.gif";